/**
 * Installed Is Types
 *
 * Contains static list of available equipment installed by types.
 */
export default [
  {
    key: 'me',
    value: 'Me',
  },
  {
    key: 'another',
    value: 'Another',
  },
  {
    key: 'unknown',
    value: 'Unknown',
  },
]
